import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  tracesSampleRate: 0.2,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  enabled: import.meta.env.PROD,
});

// Reload when the service worker takes control (new deployment activated).
// Required because app/index.html is a secondary Rollup entry point and
// vite-plugin-pwa does not inject the controllerchange listener there.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    window.location.reload();
  });
}

window.addEventListener("vite:preloadError", () => {
  const reloadKey = "dailyfi-preload-retry";
  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  const previousUrl = window.sessionStorage.getItem(reloadKey);

  if (previousUrl !== currentUrl) {
    window.sessionStorage.setItem(reloadKey, currentUrl);
    window.location.reload();
    return;
  }

  window.sessionStorage.removeItem(reloadKey);
});

createRoot(document.getElementById("root")!).render(<App />);
